import React from "react";

/**
 * Placeholder component for Quick Actions route.
 * The actual Quick Actions functionality is handled by the sidebar panel,
 * not by navigating to this route.
 */
const QuickAction = () => {
  return null;
};

export default QuickAction;







